<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="page.isNew" id="btnSave" type="submit" elevation="0" color="primary" dark
                            :loading="dataset.loading" @click="add">Salvar</v-btn>
                        <v-btn v-else id="btnSave" type="submit" elevation="0" color="primary" dark :loading="dataset.loading"
                            @click="update">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" outlined color="primary"
                            @click="goBack">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="12">
                <v-card class="form-card">
                    <!-- <v-card-title class="form-card-title">Dados do Motorista</v-card-title> -->
                    <v-card-text>
                        <v-form ref="form" v-model="valid">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="dataset.data.name" label="Nome" :rules="[$rules.required]"
                                        outlined dense hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="dataset.data.nickname" label="Apelido" outlined dense
                                        hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dataset.data.phone_number" label="Telefone"
                                        :rules="[$rules.required]" outlined dense hide-details="auto"
                                        v-mask="['(##)# ####-####']"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dataset.data.email" label="E-mail" :disabled="!page.isNew"
                                        :rules="[$rules.required, $rules.email]" outlined dense hide-details="auto"
                                        type="email"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dataset.data.registration" label="CPF"
                                        :rules="[$rules.required]" outlined dense hide-details="auto"
                                        v-mask="['###.###.###-##']"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select v-model="dataset.data.driver_type" :items="dataset.driverTypes"
                                        item-text="name" item-value="id" label="Tipo" :rules="[$rules.required]"
                                        outlined dense hide-details="auto"></v-select>
                                </v-col>
                            </v-row>

                            <v-divider class="my-4"></v-divider>

                            <v-row v-if="isPartnerDriver" class="mt-4">
                                <v-col cols="12">
                                    <div class="partner-location-header">
                                        <div>
                                            <h3 class="mb-1">Valores por localidade</h3>
                                            <span>Valor fixo recebido pelo motorista parceiro em cada localidade da viagem.</span>
                                        </div>
                                        <v-btn color="primary" small elevation="0" @click="addPartnerLocation">
                                            <v-icon left size="18">mdi-plus</v-icon>
                                            Localidade
                                        </v-btn>
                                    </div>

                                    <v-alert v-if="!dataset.data.partner_locations.length" type="info" dense text
                                        class="mt-4 mb-0">
                                        Adicione ao menos uma localidade para calcular o recebimento do parceiro no dashboard.
                                    </v-alert>

                                    <v-row v-for="(item, index) in dataset.data.partner_locations"
                                        :key="`partner-location-${index}`" class="mt-2" align="center">
                                        <v-col cols="12" md="7">
                                            <v-select v-model="item.location_id" :items="dataset.locations"
                                                item-text="name" item-value="id" label="Localidade"
                                                :rules="[$rules.required]" outlined dense hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-currency-field v-model="item.value" label="Valor" prefix="R$"
                                                :allowNegative="false" :rules="[$rules.required]" outlined dense
                                                hide-details="auto"></v-currency-field>
                                        </v-col>
                                        <v-col cols="12" md="1" class="d-flex justify-end">
                                            <v-btn icon color="red" @click="removePartnerLocation(index)"
                                                aria-label="Remover localidade">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <!-- <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-file-input v-model="dataset.profile_image" accept="image/*"
                                        label="Foto do Motorista" placeholder="Escolha uma imagem"
                                        prepend-icon="mdi-camera" show-size dense outlined
                                        @change="handleImageUpload"></v-file-input>
                                </v-col>
                            </v-row> -->

                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Financeiro: periodicidade do parceiro / salário do funcionário -->
        <v-row v-if="!page.isNew && $check(['financial.view'])">
            <v-col cols="12">
                <DriverPaymentSettings :driver-id="$route.params.id" :driver-type="dataset.data.driver_type" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import statesData from '@/common/data/states-cities.data.js';

import string from '@/common/util/string.js'
import DriverPaymentSettings from '@/layouts/components/financial/DriverPaymentSettings.vue'

export default {
    name: "DriversCreate",
    components: { DriverPaymentSettings },
    data: () => ({

        page: {
            title: '',
            isNew: false,
        },

        dataset: {
            loading: false,
            driverTypes: [
                { id: 1, name: 'Contratado' },
                { id: 2, name: 'Parceiro' },
            ],
            locations: [],
            data: {
                driver_type: 1,
                partner_locations: [],
            }
        },
    }),

    computed: {
        isPartnerDriver() {
            return Number(this.dataset.data.driver_type) === 2;
        },

        breadcrumbItems() {
            const items = [
                { text: 'Home', disabled: false, to: '/home', exact: true },
                { text: 'Motoristas', disabled: false, to: '/motoristas', exact: true },
            ];

            items.push({
                text: !this.page.isNew ? 'Editar' : 'Novo',
                disabled: true,
                exact: true,
            });
            return items;
        },
    },

    created() {
        this.setPage();
        this.loadLocations();
        this.load();
    },

    methods: {
        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Novo motorista" : "Detalhes do motorista";
        },

        async load() {
            if (this.page.isNew) return;

            this.loading = true;
            try {
                const response = await axios.get(`/api/v2/drivers/${this.$route.params.id}`);

                this.dataset.data = this.normalizeDriver(response.data.content.data)
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao carregar detalhes do motorista.', { position: 'top-right', timeout: 5000 });
                this.goBack();
            } finally {
                this.loading = false;
            }
        },

        async loadLocations() {
            try {
                const response = await axios.get('/api/v2/locations', { params: { start: 0, limit: 1000 } });
                this.dataset.locations = response.data.content ? response.data.content.data : response.data.data;
            } catch (error) {
                this.$dialog.notify.error('Erro ao carregar localidades.', { position: 'top-right', timeout: 3000 });
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar o motorista?',
                title: 'Motorista',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.post(`/api/v2/drivers`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Motorista salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o motorista?',
                title: 'Motorista',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.patch(`/api/v2/drivers/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Motorista salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                nickname: this.dataset.data.nickname,
                registration: string.sanitizeCpfCnpj(this.dataset.data.registration),
                phone_number: string.sanitizePhone(this.dataset.data.phone_number),
                email: this.dataset.data.email,
                resource_id: this.dataset.data.resource_id,
                driver_type: Number(this.dataset.data.driver_type || 1),
                partner_locations: this.isPartnerDriver
                    ? this.dataset.data.partner_locations
                        .filter((item) => item.location_id)
                        .map((item) => ({
                            location_id: item.location_id,
                            value: Number(item.value || 0),
                        }))
                    : [],
            }

            return data;
        },

        normalizeDriver(data = {}) {
            const locations = Array.isArray(data.locations) ? data.locations : [];

            return {
                ...data,
                driver_type: Number(data.driver_type || 1),
                partner_locations: locations.map((item) => ({
                    location_id: item.id || item.location_id || item.pivot_location_id,
                    value: Number(
                        item.value
                        || (item.pivot && item.pivot.value)
                        || item.pivot_value
                        || 0
                    ),
                })),
            }
        },

        addPartnerLocation() {
            this.dataset.data.partner_locations.push({ location_id: null, value: 0 });
        },

        removePartnerLocation(index) {
            this.dataset.data.partner_locations.splice(index, 1);
        },

        goBack() {
            this.$router.push('/motoristas');
        },
    },

};
</script>

<style scoped>
.partner-location-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.partner-location-header h3 {
    color: #172033;
    font-size: 16px;
    font-weight: 700;
}

.partner-location-header span {
    color: #667085;
    font-size: 13px;
}

@media (max-width: 640px) {
    .partner-location-header {
        align-items: flex-start;
        flex-direction: column;
    }
}
</style>
